import React, {ComponentProps, FC} from 'react';

import {Colors, Text} from '@optimaxdev/design-system';
import {Icon, ClockMini} from '@optimaxdev/icons';
import classNames from 'classnames';

import s from './visiblyAlert.scss';

type PropsType = {
    isMixedFrames: boolean;
    email: string;
    isVistaEyeExam?: boolean;
};

/**
 * Renders the header section of the VisiblyAlert component
 */
const VisiblyAlertHeader: FC<{isDesktop: boolean}> = ({isDesktop}) => (
    <div className={classNames(s.header, {[s.desktop]: isDesktop})}>
        <Icon
            color={Colors.pizza}
            height={isDesktop ? 16 : 14}
            icon={ClockMini}
            width={isDesktop ? 16 : 14}
        />
        <Text
            color={Colors.pizza}
            lineHeight={isDesktop ? '18px' : '20px'}
            size={isDesktop ? '16px' : '14px'}
            medium
        >
            Can&apos;t get back to your vision test?
        </Text>
    </div>
);

/**
 * Renders an alert message inside the TYP when visibly link has been sent to user
 */
export const VisiblyAlert: FC<PropsType> = ({email, isMixedFrames, isVistaEyeExam}) => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';
    const commonTextProps: ComponentProps<typeof Text> = {
        color: Colors.limedSpruce,
        lineHeight: isDesktop ? '24px' : '20px',
        size: isDesktop ? '16px' : '14px',
    };
    const inboxText = `Check your inbox at${isVistaEyeExam ? ':\u00A0' : '\u00A0'}`;

    return (
        <div
            className={classNames(s.examBox, {
                [s.desktop]: isDesktop,
                [s.isMixedFrames]: !isMixedFrames,
                [s.isVistaEyeExam]: isVistaEyeExam,
            })}
        >
            <VisiblyAlertHeader isDesktop={isDesktop} />
            <div className={classNames(s.text, {[s.desktop]: isDesktop})}>
                <div className={s.email}>
                    <Text {...commonTextProps}>{inboxText}</Text>{' '}
                    <Text {...commonTextProps} className={s.emailValue} bold>
                        {email}
                    </Text>
                </div>
                <Text {...commonTextProps}>
                    We&apos;ve emailed you the test link. Or, contact us
                    {isDesktop || isVistaEyeExam ? ' ' : <br />}
                    and we&apos;ll help you.
                </Text>
            </div>
        </div>
    );
};
